/**
 * File: src/pages/home-page.js
 * Mô tả: Trang chủ Portal SNT Games (/), giới thiệu studio, danh sách tựa game và đăng ký newsletter.
 * Liên quan: src/components/header.js, src/components/hero.js, src/components/games-showcase.js, src/components/footer.js
 */

import { games } from '../data/games.js';
import { renderHero } from '../components/hero.js';
import { renderGamesShowcase } from '../components/games-showcase.js';
import { renderAbout } from '../components/about.js';
import { renderNewsletterForm } from '../components/newsletter-form.js';
import { createElement } from '../utils/dom.js';

export const renderHomePage = () => {
  const container = createElement('div', { className: 'home-page-container' });

  const featuredGame = games.find((g) => g.featured) || games[0];

  container.appendChild(renderHero(featuredGame));
  container.appendChild(renderGamesShowcase(games));
  container.appendChild(renderAbout());
  container.appendChild(renderNewsletterForm());

  return container;
};
